import { apiClient } from '../../lib/apiClient'
import type { ApiResponse } from '../../types'
import type { Appointment, AppointmentStatus, ConsultationMode, PublicDoctor, Slot } from './appointment.types'

export async function getPublicDoctor(doctorId?: number) {
  return (await apiClient.get<ApiResponse<PublicDoctor>>('/public/doctor', { params: { doctor_id: doctorId } })).data.data
}

export async function getSlots(doctorId: number, date: string, serviceId: number, mode: ConsultationMode) {
  const response = await apiClient.get<ApiResponse<Slot[]>>(`/public/doctors/${doctorId}/available-slots`, {
    params: { date, service_id: serviceId, consultation_mode: mode },
  })
  return response.data.data
}

export async function getPatientAppointments(status?: string, date?: string, page = 1) {
  const response = (await apiClient.get<ApiResponse<Appointment[]>>('/patient/appointments', { params: { ...(status ? { status } : {}), ...(date ? { date } : {}), page } })).data
  return { items: response.data, meta: response.meta }
}

export async function getDoctorAppointments(params: Record<string, string> = {}) {
  return (await apiClient.get<ApiResponse<Appointment[]>>('/doctor/appointments', { params })).data.data
}

export async function getAppointment(role: 'patient' | 'doctor' | 'admin', id: string) {
  return (await apiClient.get<ApiResponse<Appointment>>(`/${role}/appointments/${id}`)).data.data
}

export async function bookAppointment(data: FormData) {
  return (await apiClient.post<ApiResponse<Appointment>>('/patient/appointments', data)).data.data
}

export async function cancelAppointment(id: number, reason: string) {
  return (await apiClient.patch<ApiResponse<Appointment>>(`/patient/appointments/${id}/cancel`, { reason })).data.data
}

export async function rescheduleAppointment(id: number, appointmentDate: string, startTime: string, consultationMode: ConsultationMode) {
  return (await apiClient.patch<ApiResponse<Appointment>>(`/patient/appointments/${id}/reschedule`, {
    appointment_date: appointmentDate, start_time: startTime, consultation_mode: consultationMode,
  })).data.data
}

export async function updateAppointmentStatus(id: number, status: AppointmentStatus) {
  return (await apiClient.patch<ApiResponse<Appointment>>(`/doctor/appointments/${id}/status`, { status })).data.data
}
